module.exports = __webpack_public_path__ + "img/no_more.a621b6f4.png";